var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"woocommerce-notices-wrapper"},[_c('div',{staticClass:"woocommerce-message",attrs:{"id":"notice","role":"alert"}},[_c('i',{staticClass:"fa fa-times",on:{"click":_vm.unset}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }